'use client'

import { useWishlistStore } from '@/store'
import Image from 'next/image'
import { toast } from 'react-toastify'

interface WishlistProps {
  isWishList?: boolean
  data?: Product
  quantity?: number
  productSelected?: {
    product: IVariantsProduct | undefined
    options: Record<string, string>
  }
  dataWishlist?:IWishlistItem
  customRender?: React.ReactNode
}

export const WishlistButton = ({ isWishList = false, data, quantity, productSelected, dataWishlist, customRender }: WishlistProps) => {
  const { addToWishlist, removeItemFromWishlist } = useWishlistStore()
  const wishlistItems: any = {
    sku: productSelected?.product?.product?.sku ?? data?.sku,
    quantity: quantity ?? 1,
  }
  if (productSelected?.options) wishlistItems.selected_options = [...Object.values(productSelected?.options)]
  if (productSelected?.product) wishlistItems.parent_sku = data?.sku


  const handleAddToWishlist = async() => {
    let result
    let idToast = toast.loading('Processing')
    if(isWishList){
      if(!dataWishlist?.id) return
      result = await removeItemFromWishlist(dataWishlist?.id)
    }else{
      result = await addToWishlist({ wishlistItems })
    }
    toast.update(idToast, {
      render: result?.message,
      type: result?.status ?? 'success',
      isLoading: false,
      autoClose: 3 * 1000,
      closeButton: true,
    })
  }
  if(customRender) return <div onClick={handleAddToWishlist}>{customRender}</div>
  return (
    <div className={`border border-gray-300 rounded-md bg-white text-black p-2 z-10 cursor-pointer transition-colors hover:bg-black hover:text-white hover:border-black sm:flex sm:border-none sm:items-center sm:justify-center sm:rounded-sm ${isWishList ? "bg-black text-white border-black" : ""}`} onClick={handleAddToWishlist}>
      <Image
        className={`sm:w-6 ${isWishList ? "brightness-0 invert" : "hover:brightness-0 hover:invert"}`}
        src={isWishList ? '/assets/images/icon_heart_red.svg' : '/assets/images/icon_heart.svg'}
        width={24}
        height={24}
        alt=""
      />
    </div>
  )
}